import { Builder } from '@builder.io/react';
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { FC, useEffect, useState } from 'react';

import { registerComponents } from '@/builder';
import { Locale } from '@/helpers/LangHelper';
import { BuilderModel, createStaticPaths, createStaticProps, getBuilderPreviewPage } from '@/utils/Builder';
import { NotFound } from '@/components/not-found';

registerComponents();

const B2BPage = dynamic(() => import('@/modules/B2BPage'));

export async function getStaticPaths() {
    return createStaticPaths(false, Locale.USA);
}

export async function getStaticProps({ params }: GetStaticPropsContext<any>) {
    const usParams = {
        ...params,
    };

    if (params.slug) {
        if (Array.isArray(params.slug)) {
            usParams.slug = [Locale.USA, ...params.slug];
        } else {
            usParams.slug = params.slug;
        }
    }

    return createStaticProps({ params: usParams, includeUnpublished: false });
}

const PageRoot: FC<InferGetStaticPropsType<typeof getStaticProps>> = (props) => {
    const { page, model } = props;

    const [previewPage, setPreviewPage] = useState<any>(page);
    const [previewModel, setPreviewModel] = useState<BuilderModel>(model);

    const router = useRouter();

    const _getBuilderPreviewPage = async () => {
        const previewData = await getBuilderPreviewPage(router);
        if (previewData) {
            setPreviewPage(previewData.page);
            setPreviewModel(previewData.model);
        }
    };

    useEffect(() => {
        if (!(Builder.isEditing || Builder.isPreviewing)) return;
        // if (page) return;
        if (router.isFallback) return;

        _getBuilderPreviewPage();
    }, [page, router]);

    useEffect(() => {
        setPreviewPage(page);
    }, [page]);

    useEffect(() => {
        setPreviewModel(model);
    }, [model]);

    if (router.isFallback) {
        return <h1>Loading...</h1>;
    }

    if (previewPage === null) {
        return <NotFound locale={Locale.USA} />;
    }

    return <B2BPage page={previewPage} model={previewModel} />;
};

export default PageRoot;
